module.exports = __webpack_public_path__ + "img/t3-purple.51eccb25.png";